import { render, staticRenderFns } from "./losschart.vue?vue&type=template&id=2cd4fdfc&scoped=true&"
import script from "./losschart.vue?vue&type=script&lang=js&"
export * from "./losschart.vue?vue&type=script&lang=js&"
import style0 from "./losschart.vue?vue&type=style&index=0&id=2cd4fdfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd4fdfc",
  null
  
)

export default component.exports